<script setup lang="ts">
import { DialogDescription, type DialogDescriptionProps, useForwardProps } from 'radix-vue'
import { type HTMLAttributes, computed } from 'vue'

const props = defineProps<DialogDescriptionProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props

	return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
	<dialog-description
		v-bind="forwardedProps"
		:class="cn('text-sm text-muted-foreground', props.class)"
	>
		<slot />
	</dialog-description>
</template>
